import React from "react";
import { StyleSheet, Dimensions, TouchableOpacity, Image } from "react-native";
import Ionicon from "react-native-vector-icons/Ionicons";
import * as Progress from "react-native-progress";
import { Box } from "app/components/common";
import Logo from "./LongLogo";
import theme from "app/Theme/Theme";
import { isWeb } from "@microdoing/shared/utils/deviceDetectors";
import LogoFullMicrodoing from "app/components/Icons/logo/LogoFullMicrodoing";

const { width } = Dimensions.get("window");

interface IProps {
  progress: number;
  onPressExit: () => null;
}

const SignupHeader = ({ progress = 0, onPressExit }: IProps) => {
  return (
    <Box flexDirection="column" alignItems="center" width="100%" marginTop="xs">
      <Box width="100%" justifyContent="center" alignItems="center">
        {!!onPressExit && (
          <TouchableOpacity
            testID="settings"
            hitSlop={{ top: 20, bottom: 20, left: 20, right: 20 }}
            style={styles.settings}
            onPress={onPressExit}
          >
            <Ionicon
              name="close-circle-outline"
              size={25}
              color={theme.colors["neutral.400"]}
            />
          </TouchableOpacity>
        )}
        <LogoFullMicrodoing />
        {/* <Logo color={theme.colors["neutral.900"]} /> */}
      </Box>
    </Box>
  );
};

const styles = StyleSheet.create({
  settings: {
    position: "absolute",
    zIndex: 10,
    right: 0,
    top: 5,
  },
});

export default SignupHeader;
